module.exports = __webpack_public_path__ + "static/2.79bd84c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/2.jpg
// module id = 698
// module chunks = 168707334958949